import {
    IActivityFilter,
    ICrmFilter,
    IOptions,
    IOrganizationFilter,
    IPersonalFilter,
    IProspectSearchFilters,
} from '../../../interfaces';

export class ProspectSearchFiltersDto implements IProspectSearchFilters {
    organizationFilter?: IOrganizationFilter;
    personalFilter?: IPersonalFilter;
    crmFilters?: ICrmFilter;
    activityFilters?: IActivityFilter;
    options?: IOptions;

    constructor(iProspectSearchFilters: ProspectSearchFiltersDto) {
        this.organizationFilter = iProspectSearchFilters.organizationFilter || {};
        this.personalFilter = iProspectSearchFilters.personalFilter || {};
        this.crmFilters = iProspectSearchFilters.crmFilters || {};
        this.activityFilters = iProspectSearchFilters.activityFilters || {};
        this.options = iProspectSearchFilters.options || {};
    }
}
